import { ApiError } from './api-client'

/**
 * ISSUE-PREVIEW-20260820-002: authorization/validation failures were shown
 * as the server's raw English default text (e.g. "You do not have
 * permission to perform this action.") regardless of the UI's selected
 * language — `common:apiError.<CODE>` (see the locale files) gives every
 * one of `packages/shared`'s `ERROR_CODES` a real zh-TW/en translation.
 *
 * Precedence: a field-specific `error.details` message (already more
 * actionable than any generic text, see ISSUE-PREVIEW #13) wins first;
 * otherwise the code-based translation; otherwise `fallback`. This
 * deliberately does not fall through to the raw untranslated
 * `error.message` — a caller-supplied `fallback` should itself come from
 * `t()`, keeping every path localized.
 *
 * Known gap: `error.details` values are still whatever raw string the API
 * route passed to `validationError()` — those are not translated by this
 * helper (a much larger, open-ended surface of per-route custom messages,
 * out of scope here). Only the generic `error.code` layer is covered.
 */
export function apiErrorMessage(
  error: unknown,
  t: (key: string) => string,
  fallback: string,
): string {
  if (!(error instanceof ApiError)) return fallback
  if (error.details !== undefined) {
    for (const value of Object.values(error.details)) {
      if (Array.isArray(value) && typeof value[0] === 'string') return value[0]
    }
  }
  const key = `common:apiError.${error.code}`
  const translated = t(key)
  return translated === key ? fallback : translated
}
